import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Modules from "./pages/Modules";
import Layout from "./pages/Layout";
import Dashboard from "./pages/Dashboard";
import ReportsList from "./pages/ReportsList";
import NewReport from "./pages/NewReport";
import ReportDetail from "./pages/ReportDetail";
import BandeosList from "./pages/BandeosList";
import NewBandeo from "./pages/NewBandeo";
import BandeoDetail from "./pages/BandeoDetail";
import MaquillajesList from "./pages/MaquillajesList";
import NewMaquillaje from "./pages/NewMaquillaje";
import MaquillajeDetail from "./pages/MaquillajeDetail";
import AdminUsers from "./pages/AdminUsers";
import AdminBrands from "./pages/AdminBrands";
import AdminMap from "./pages/AdminMap";
import "./App.css";

// Remove Emergent badge if present
if (typeof window !== "undefined") {
  const remove = () => {
    const el = document.getElementById("emergent-badge");
    if (el) el.remove();
  };
  remove();
  // Run on DOM ready too in case the script tag loads after
  if (document.readyState !== "complete") {
    window.addEventListener("load", remove);
    document.addEventListener("DOMContentLoaded", remove);
  }
  // Watch in case it gets re-injected
  const obs = new MutationObserver(() => remove());
  obs.observe(document.documentElement, { childList: true, subtree: true });
}

function Protected({ children, adminOnly = false, bandeoOnly = false, tradeOnly = false, maquillajeOnly = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="kbd-label">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/modules" replace />;
  if (bandeoOnly && user.role !== "admin" && user.can_bandeo !== true) return <Navigate to="/modules" replace />;
  if (tradeOnly && user.role !== "admin" && user.can_trade !== true) return <Navigate to="/modules" replace />;
  if (maquillajeOnly && user.role !== "admin" && user.can_maquillaje !== true) return <Navigate to="/modules" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/modules" element={<Protected><Modules /></Protected>} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Navigate to="/modules" replace />} />
            <Route path="dashboard" element={<Protected tradeOnly><Dashboard /></Protected>} />
            <Route path="reports" element={<Protected tradeOnly><ReportsList /></Protected>} />
            <Route path="reports/new" element={<Protected tradeOnly><NewReport /></Protected>} />
            <Route path="reports/:id/edit" element={<Protected tradeOnly><NewReport /></Protected>} />
            <Route path="reports/:id" element={<Protected tradeOnly><ReportDetail /></Protected>} />
            <Route path="bandeos" element={<Protected bandeoOnly><BandeosList /></Protected>} />
            <Route path="bandeos/new" element={<Protected bandeoOnly><NewBandeo /></Protected>} />
            <Route path="bandeos/:id/edit" element={<Protected bandeoOnly><NewBandeo /></Protected>} />
            <Route path="bandeos/:id" element={<Protected bandeoOnly><BandeoDetail /></Protected>} />
            <Route path="maquillajes" element={<Protected maquillajeOnly><MaquillajesList /></Protected>} />
            <Route path="maquillajes/new" element={<Protected maquillajeOnly><NewMaquillaje /></Protected>} />
            <Route path="maquillajes/:id/edit" element={<Protected maquillajeOnly><NewMaquillaje /></Protected>} />
            <Route path="maquillajes/:id" element={<Protected maquillajeOnly><MaquillajeDetail /></Protected>} />
            <Route path="admin/users" element={<Protected adminOnly><AdminUsers /></Protected>} />
            <Route path="admin/brands" element={<Protected adminOnly><AdminBrands /></Protected>} />
            <Route path="admin/map" element={<Protected adminOnly><AdminMap /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/modules" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
